/**
 * firebase functionのonCallで実装されているエンドポイントを呼び出すメソッド。
 */
import '../../firebase'
import firebase from 'firebase/app'
const fn = firebase.functions()

export const describePaymentSource = fn.httpsCallable('describePaymentSource')
export const updatePaymentSource = fn.httpsCallable('updatePaymentSource')
export const startSubscription = fn.httpsCallable('startSubscription')
export const deleteSubscription = fn.httpsCallable('deleteSubscriptionPlan')
export const stopSubscription = fn.httpsCallable('stopSubscription')

export default fn
